const GSM_BASIC_CHARACTERS = new Set(
  Array.from(
    "@\u00a3$\u00a5\u00e8\u00e9\u00f9\u00ec\u00f2\u00c7\n\u00d8\u00f8\r\u00c5\u00e5\u0394_\u03a6\u0393\u039b\u03a9\u03a0\u03a8\u03a3\u0398\u039e\u00c6\u00e6\u00df\u00c9 !\"#\u00a4%&'()*+,-./0123456789:;<=>?\u00a1ABCDEFGHIJKLMNOPQRSTUVWXYZ\u00c4\u00d6\u00d1\u00dc\u00a7\u00bfabcdefghijklmnopqrstuvwxyz\u00e4\u00f6\u00f1\u00fc\u00e0",
  ),
);

const GSM_EXTENDED_CHARACTERS = new Set(Array.from("\f^{}\\[~]|\u20ac"));

// Keep this policy consistent in the web and mobile manual SMS send paths.
export const MANUAL_SMS_TOO_LONG =
  "Your message is too long. Please shorten it or share detailed instructions through your guest guide.";
export const MANUAL_SMS_MAX_SEGMENTS = 8;

export const withManualSmsSignature = (message, signatureSettings) => {
  const body = String(message || "");
  const signature = String(signatureSettings?.signature_text || "").trim();
  return signatureSettings?.enabled && signature
    ? `${body.trim()}\n\n${signature}`
    : body;
};

export const isTollFreeSmsSender = (sender = "") =>
  /^1(?:800|888|877|866|855|844|833)\d{7}$/.test(
    String(sender).replace(/\D/g, ""),
  );

// Count the actual outgoing text, not estimated template placeholders. UTF-16
// length accounts for emoji's surrogate pairs; GSM escape characters use 2 units.
export const getSmsSegmentCount = (body = "", sender = "") => {
  let gsmUnits = 0;
  let unicode = false;
  for (const character of String(body)) {
    if (GSM_BASIC_CHARACTERS.has(character)) gsmUnits += 1;
    else if (GSM_EXTENDED_CHARACTERS.has(character)) gsmUnits += 2;
    else {
      unicode = true;
      break;
    }
  }
  const units = unicode ? String(body).length : gsmUnits;
  const singleLimit = unicode ? 70 : 160;
  const multipartLimit = unicode
    ? (isTollFreeSmsSender(sender) ? 66 : 67)
    : (isTollFreeSmsSender(sender) ? 152 : 153);
  if (units === 0) return 0;
  if (units <= singleLimit) return 1;
  let segments = 1;
  let usedUnits = 0;
  for (const character of String(body)) {
    const characterUnits = unicode
      ? character.length
      : GSM_EXTENDED_CHARACTERS.has(character) ? 2 : 1;
    if (usedUnits + characterUnits > multipartLimit) {
      segments += 1;
      usedUnits = 0;
    }
    usedUnits += characterUnits;
  }
  return segments;
};

export const getManualSmsError = (message, { signature, sender } = {}) => {
  const body = withManualSmsSignature(message, signature);
  return (
    body.length > 1600 ||
    getSmsSegmentCount(body, sender) > MANUAL_SMS_MAX_SEGMENTS
  )
    ? MANUAL_SMS_TOO_LONG
    : null;
};
